import React from 'react';
import { Box, Button } from '@mui/material';

interface QuizAutoButtonProps {
  onAuto: () => void;
}

const QuizAutoButton: React.FC<QuizAutoButtonProps> = ({ onAuto }) => (
  <Box
    sx={{
      position: 'fixed',
      top: 120,
      right: 'calc(50vw - 380px)',
      zIndex: 1200,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}
  >
    <Button
      variant="outlined"
      size="small"
      sx={{
        borderRadius: '50%',
        minWidth: 0,
        width: 48,
        height: 48,
        mb: 2,
        fontWeight: 700,
        fontFamily: '"Baloo 2", Arial, sans-serif',
        background: '#fffbe6',
        color: '#800020',
        boxShadow: 2,
        '&:hover': { background: '#ffe5b4' },
      }}
      onClick={onAuto}
    >
      Auto
    </Button>
  </Box>
);

export default QuizAutoButton;